import { render, staticRenderFns } from "./shippingTerm.vue?vue&type=template&id=443afcff&"
import script from "./shippingTerm.vue?vue&type=script&lang=js&"
export * from "./shippingTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('443afcff')) {
      api.createRecord('443afcff', component.options)
    } else {
      api.reload('443afcff', component.options)
    }
    module.hot.accept("./shippingTerm.vue?vue&type=template&id=443afcff&", function () {
      api.rerender('443afcff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/shippingTerm.vue"
export default component.exports